export const SET_AUDIO_TIME = 'SET_AUDIO_TIME';
export const SET_MOVE_TIME = 'SET_MOVE_TIME';
export const TOGGLE_PLAY = 'TOGGLE_PLAY';
export const RESET_STATE = 'RESET_STATE';
export const SET_VOLUME = 'SET_VOLUME';

export const setAudioTime = (value) => ({
  type: SET_AUDIO_TIME,
  payload: value
});

export const setMoveToTime = (value) => ({
  type: SET_MOVE_TIME,
  payload: value
});

export const togglePlay = (value) => ({
  type: TOGGLE_PLAY,
  payload: value
});

export const resetState = () => ({
  type: RESET_STATE
});

export const setVolume = (value) => ({
  type: SET_VOLUME,
  payload: value
});

